// extracted by mini-css-extract-plugin
module.exports = {"image-gallery":"ImageGallery_image-gallery__2jKzm"};